import { GenericType } from './../base/edl-generic-type.model';
import { ObservationTypeUrlTags } from './observation-type-url-tags.enum';
import { ObservationTypeValues } from './observation-type-values.enum';

export class ObservationTypes {

    public static List: Array<{ Label: string, Value: ObservationTypeValues, URLTag: ObservationTypeUrlTags, UseDashboard: boolean }> = [
        { Label: "Walkthrough", Value: ObservationTypeValues.Walkthrough, URLTag: ObservationTypeUrlTags.Walkthrough, UseDashboard: false },
        { Label: "Differentiated", Value: ObservationTypeValues.Differentiated, URLTag: ObservationTypeUrlTags.Differentiated, UseDashboard: true },
        { Label: "Formal", Value: ObservationTypeValues.Formal, URLTag: ObservationTypeUrlTags.Formal, UseDashboard: true },
        { Label: "Rubric", Value: ObservationTypeValues.Rubric, URLTag: ObservationTypeUrlTags.Rubric, UseDashboard: false },
        { Label: "Anecdotal Note", Value: ObservationTypeValues.Anecdotal, URLTag: ObservationTypeUrlTags.Anecdotal, UseDashboard: false },
        { Label: "SLO", Value: ObservationTypeValues.SLO, URLTag: ObservationTypeUrlTags.SLO, UseDashboard: false },
        { Label: "Principal SLO", Value: ObservationTypeValues.PrincipalSLO, URLTag: ObservationTypeUrlTags.PrincipalSLO, UseDashboard: false },
        { Label: "NTP Observation", Value: ObservationTypeValues.NTPE, URLTag: ObservationTypeUrlTags.NTPE, UseDashboard: true },
        { Label: "Rating Form", Value: ObservationTypeValues.X82, URLTag: ObservationTypeUrlTags.X82, UseDashboard: false },
        { Label: "Custom Forms", Value: ObservationTypeValues.CustomForm, URLTag: ObservationTypeUrlTags.CustomForm, UseDashboard: false },
        { Label: "Performance Goal", Value: ObservationTypeValues.PerformanceGoal, URLTag: ObservationTypeUrlTags.SPM_IEP_PG, UseDashboard: true },
        { Label: "IEP Goals Progress", Value: ObservationTypeValues.IEP, URLTag: ObservationTypeUrlTags.SPM_IEP_PG, UseDashboard: true },
        { Label: "Student Performance Measure", Value: ObservationTypeValues.SPM, URLTag: ObservationTypeUrlTags.SPM_IEP_PG, UseDashboard: true }
    ]

    public static readonly Walkthrough = new GenericType(ObservationTypeValues.Walkthrough, "Walkthrough");
    public static readonly Differentiated = new GenericType(ObservationTypeValues.Differentiated, "Differentiated");
    public static readonly Formal = new GenericType(ObservationTypeValues.Formal, "Formal");
    public static readonly Rubric = new GenericType(ObservationTypeValues.Rubric, "Rubric");
    public static readonly Anecdotal = new GenericType(ObservationTypeValues.Anecdotal, "Anecdotal Note");
    public static readonly SLO = new GenericType(ObservationTypeValues.SLO, "SLO")
    public static readonly PrincipalSLO = new GenericType(ObservationTypeValues.PrincipalSLO, "Principal SLO");
    public static readonly NTPE = new GenericType(ObservationTypeValues.NTPE, "NTP Observation")
    public static readonly RatingForm = new GenericType(ObservationTypeValues.X82, "Rating Form")
    public static readonly CustomForm = new GenericType(ObservationTypeValues.CustomForm, "Custom Forms")
    public static readonly PG = new GenericType(ObservationTypeValues.PerformanceGoal, "PG")
    public static readonly IEP = new GenericType(ObservationTypeValues.IEP, "IEP")
    public static readonly SPM = new GenericType(ObservationTypeValues.SPM, "SPM")


    public static GetObservationTypeURLTag = (type?: number) => {
        return this.List.find((x: { Value: number | undefined; }) => x.Value == type)?.URLTag;
    }

    public static GetObservationType = function (type?: ObservationTypeValues) {
        switch (type) {
            case ObservationTypeValues.Differentiated:
                return ObservationTypes.Differentiated;
            case ObservationTypeValues.Formal:
                return ObservationTypes.Formal;
            case ObservationTypeValues.Rubric:
                return ObservationTypes.Rubric;
            case ObservationTypeValues.Walkthrough:
                return ObservationTypes.Walkthrough;
            case ObservationTypeValues.Anecdotal:
                return ObservationTypes.Anecdotal;
            case ObservationTypeValues.SLO:
                return ObservationTypes.SLO;
            case ObservationTypeValues.PrincipalSLO:
                return ObservationTypes.PrincipalSLO;
            case ObservationTypeValues.NTPE:
                return ObservationTypes.NTPE;
            case ObservationTypeValues.X82:
                return ObservationTypes.RatingForm;
            case ObservationTypeValues.CustomForm:
                return ObservationTypes.CustomForm;
            case ObservationTypeValues.PerformanceGoal:
                return ObservationTypes.PG;
            case ObservationTypeValues.IEP:
                return ObservationTypes.IEP;
            case ObservationTypeValues.SPM:
                return ObservationTypes.SPM;
            default:
                return undefined;
        }
    }

    public static GetUserSummaryTabIndex = function (type?: ObservationTypeValues) {
        switch (type) {
            case ObservationTypeValues.Differentiated:
                return 3;
            case ObservationTypeValues.Formal:
                return 3;
            case ObservationTypeValues.Rubric:
                return 3;
            case ObservationTypeValues.Walkthrough:
                return 2;
            case ObservationTypeValues.Anecdotal:
                return 4;
            case ObservationTypeValues.SLO:
                return 1;
            case ObservationTypeValues.PrincipalSLO:
                return 1;
            case ObservationTypeValues.NTPE:
                return 3;
            case ObservationTypeValues.X82:
                return 6;
            case ObservationTypeValues.CustomForm:
                return 5;
            case ObservationTypeValues.PerformanceGoal:
                return 1;
            case ObservationTypeValues.IEP:
                return 1;
            case ObservationTypeValues.SPM:
                return 1;
            default:
                return 0;
        }
    }

    public static GetGuidanceLinkURL = function (type?: ObservationTypeValues): string {
        switch (type) {
            case ObservationTypeValues.Differentiated:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101872";
            case ObservationTypeValues.Formal:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101871";
            case ObservationTypeValues.Rubric:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000104366";
            case ObservationTypeValues.Walkthrough:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101869";
            case ObservationTypeValues.Anecdotal:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101870";
            case ObservationTypeValues.SLO:
                return '';
            case ObservationTypeValues.PrincipalSLO:
                return '';
            case ObservationTypeValues.NTPE:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101875-ntpe-observations";
            case ObservationTypeValues.X82:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101902-13-rating-forms";
            case ObservationTypeValues.CustomForm:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000104989";
            case ObservationTypeValues.PerformanceGoal:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101876";
            case ObservationTypeValues.IEP:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101874";
            case ObservationTypeValues.SPM:
                return "https://edulinksolutions.freshdesk.com/support/solutions/articles/13000101873";
            default:
                return "https://edulinksolutions.freshdesk.com/support/solutions/folders/13000019460";
        }
    }

    public static HasRubricLanaguge(type?: ObservationTypeValues) {
        switch (type) {
            case ObservationTypeValues.Formal:
            case ObservationTypeValues.Rubric:
            case ObservationTypeValues.NTPE:
            case ObservationTypeValues.Differentiated:
            case ObservationTypeValues.PrincipalSLO:
                return true;
            case ObservationTypeValues.Anecdotal:
            case ObservationTypeValues.Walkthrough:
            case ObservationTypeValues.CustomForm:
            case ObservationTypeValues.SLO:
            case ObservationTypeValues.X82:
            case ObservationTypeValues.PerformanceGoal:
            case ObservationTypeValues.IEP:
            case ObservationTypeValues.SPM:
                return false;
            default:
                return false;
        }
    }

}

